import {
  HttpClient,
  HttpHeaders
} from '@angular/common/http';
import {
  Injectable
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LocalstorageService } from '../storage/localstorage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticatorService {
  private loadingSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private errorPopupSubject: BehaviorSubject<any> = new BehaviorSubject<any>({show:false,message:''});
  loading$ = this.loadingSubject.asObservable();
  errorPopup$ = this.errorPopupSubject.asObservable();

  constructor(
    public http: HttpClient,
    private localStorage: LocalstorageService,
    // private errorComponent: ErrorPopupComponent
  ) { }

  showLoading() {
    this.loadingSubject.next(true);
  }

  hideLoading() {
    this.loadingSubject.next(false);
  }

  showError(message:any){
    this.errorPopupSubject.next({show:true,message:message})
  }
  

  public async getFromApi( metodo:any, dadosLogin: any, callbackfunction: any, ShowLoading: boolean, ApiUrl: string) {

    return new Promise((resolve, reject)=> {

      this.http.get("assets/config.json?" + Math.random()).subscribe( async data => {
        let config = JSON.parse(JSON.stringify(data))
        ApiUrl = config.urlAuthenticator;
        var ApiKey = config.tokenAuthenticator

        if (ApiUrl.charAt(ApiUrl.length - 1) == '/') {
          ApiUrl = ApiUrl.slice(0, -1);
        }
  
        var url = ApiUrl + "/" + metodo;

        var httpOption = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            })
        }
        var dados = {}

        if(metodo == "cadastro"){
          this.http.get(url+'/XMLVisio/'+dadosLogin.usuario).toPromise()
          .then(async (result:any) =>{

            if (callbackfunction != undefined) {
              await callbackfunction(result);
            }
            if (ShowLoading) {
              setTimeout( () => {
                this.hideLoading();
                // LoadingComponent.Hide();
              }, 500); //RETORNAR PARA 500 MILESIMOS - 1000 PARA TESTE COM LIVE SHARE VSCODE
            }
            Promise.resolve(result);
          })
          .catch(async (error:any) =>{
            console.log(error)
            if (ShowLoading) {
              setTimeout( () => {
              this.hideLoading();
              }, 500);
            }

            var ErrorMsg = "";
            if (error.error instanceof ErrorEvent) {
              ErrorMsg = error.error.text;
            } else {
              if(typeof(error) == 'object'){
                if(typeof(error.error) == 'object'){
                  ErrorMsg = error.error.text;
                }else{
                  ErrorMsg = error.error;
                }
              }else{
                ErrorMsg = error;
              }
            }
            this.showError(ErrorMsg)
          });
        }else{
            httpOption = {
              headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Authorization : 'basic '+ApiKey
              })
            }
  
          if(metodo == "valida_otp"){
            var token = await JSON.parse(this.localStorage.getData('SESSION'));
             dados = {
              software  : "XMLVisio", 
              username  : dadosLogin.usuario,
              otp       : dadosLogin.otp_code,
              token     : token
            }
          }else{
  
             dados = {
              software    : "XMLVisio", 
              username    : dadosLogin.usuario
            }
          }
          if (!navigator.onLine) {
            Promise.reject("Sem internet");
            return;
          }
    
          if (ShowLoading) {
            this.showLoading();
          }
          
          this.http.post<any>(url, dados, httpOption).toPromise()
            .then(async (result: any) => {
              if (callbackfunction != undefined) {
                await callbackfunction(result);
              }
              if (ShowLoading) {
                setTimeout( () => {
                  this.hideLoading();
                  // LoadingComponent.Hide();
                }, 500); //RETORNAR PARA 500 MILESIMOS - 1000 PARA TESTE COM LIVE SHARE VSCODE
              }
              Promise.resolve(result);
    
            })
            .catch(async (error:any) => {
              console.log(error)
              if (ShowLoading) {
                setTimeout( () => {
                this.hideLoading();
                }, 500);
              }
  
              var ErrorMsg = "";
              if (error.error instanceof ErrorEvent) {
                ErrorMsg = error.error.text;
              } else {
                if(typeof(error) == 'object'){
                  if(typeof(error.error) == 'object'){
                    ErrorMsg = error.error.text;
                  }else{
                    ErrorMsg = error.error;
                  }
                }else{
                  ErrorMsg = error;
                }
              }
              this.showError(ErrorMsg)
            });
        }
        
      })
    })
  }

}
